import { lazy } from "react";
import { createRoot } from "react-dom/client";

import { useVhCalculate } from "common/hooks/use-vh-calculate";
import { useVisualViewportCalculate } from "common/hooks/use-visual-viewport-calculate";

const LandingEntry = lazy(() => import("./entries/landing-entry"));
const AppEntry = lazy(() => import("./entries/app-entry"));

const isLandingUrl = (url: string) => {
  if (process.env.BINDING_ENV === "production") {
    return url.startsWith("https://binding.at");
  }

  return url.startsWith("http://127.0.0.1:5173/landing");
};

const RootDecision = () => {
  useVisualViewportCalculate();
  useVhCalculate();

  if (isLandingUrl(window.location.href)) {
    return <LandingEntry />;
  }

  return <AppEntry />;
};

const rootEl = document.getElementById("root");
createRoot(rootEl).render(<RootDecision />);
